import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectIsAuthenticated, selectUser } from '../store/slices/authSlice';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import './Profile.css';

function Profile() {
  const navigate = useNavigate();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector(selectUser);

  // Redirect to home if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated || !user) {
    return null; // Will redirect
  }

  return (
    <div className="profile-page">
      <Navbar />
      <div className="profile-container">
        <div className="profile-card">
          <div className="profile-header">
            <div className="profile-avatar">
              {user.profilePictures?.[0] ? (
                <img src={user.profilePictures[0]} alt={user.name || 'Profile'} />
              ) : (
                <div className="avatar-placeholder">
                  {user.firstName?.charAt(0) || user.name?.charAt(0) || 'U'}
                </div>
              )}
            </div>
            <h1 className="profile-name">
              {user.firstName && user.lastName 
                ? `${user.firstName} ${user.lastName}` 
                : user.name || 'User'}
            </h1>
            <p className="profile-email">{user.email}</p>
          </div>

          <div className="profile-section">
            <h2 className="section-title">Profile Information</h2>
            
            <div className="profile-info-grid">
              <div className="info-item">
                <span className="info-label">Email</span>
                <span className="info-value">{user.email || 'N/A'}</span>
              </div>
              
              <div className="info-item">
                <span className="info-label">Phone</span>
                <span className="info-value">{user.contactNumber || user.phone || 'N/A'}</span>
              </div>
              
              <div className="info-item">
                <span className="info-label">Location</span>
                <span className="info-value">{user.location || 'N/A'}</span>
              </div>
              
              <div className="info-item">
                <span className="info-label">Role</span>
                <span className="info-value capitalize">{user.role || 'User'}</span>
              </div>
            </div>
          </div>

          <div className="profile-actions">
            <button className="profile-btn secondary" onClick={() => navigate('/')}>
              Back to Home
            </button>
            <button className="profile-btn secondary">
              Delete my Account
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Profile;
